import { I18nComponente } from "@/types/gerais"

export const NovoUsuarioi18n: I18nComponente = {
  "pt-BR": {
    editar: "editar",
    salvar: "salvar",
    cancelar: "cancelar",
    doUsuario: "do usuário?",
    aoCancelarVocePerdera: "Ao cancelar você perderá todas",
    asInformacoesNaoSalvas: "as informações não salvas",
    voltarEditar: "voltar e editar",
    simCancelar: "sim, cancelar",
    usuarios: "usuários",
    dadosDeAcessoResponsabilidades: "dados de acesso e responsabilidades",
    atributosParaAlocacaoDoProfissional: "atributos para alocação do profissional",
    criarNovoUsuario: "criar novo usuário",
    usuarioEditado: "Usuário editado!",
    usuario: "Usuário",
    editadoComSucesso: "editado com sucesso",
    criadoComSucesso: "criado com sucesso",
    erroAoTentarCriarUsuario: "Erro ao tentar criar usuário",
    erroAoTentarEditarUsuario: "Erro ao tentar editar usuário",
    fotoAlterada: "Foto alterada",
    fotoDoUsuarioAlteradaComSucesso: "A foto do usuário alterada com sucesso",
    erroAoAlterarFoto: "Erro ao alterar foto",
    ocorreuUmErroAoAlterarFoto: "Ocorreu um erro ao alterar a foto do usuário",
    usuarioCriado: "Usuário criado!",
    camposInvalidos: "Campos inválidos",
    preenchaCorretamenteOsCampos: "Preencha corretamente os campos",
    erroInesperado: "Erro inesperado",
    naoFoiPossivelEncontrarUsuario: "Não foi possível encontrar o usuário",
  },
  "es-CO": {
    editar: "editar",
    salvar: "guardar",
    cancelar: "cancelar",
    doUsuario: "del usuario?",
    aoCancelarVocePerdera: "Al cancelar perderás todas",
    asInformacoesNaoSalvas: "las informaciones no guardadas",
    voltarEditar: "volver y editar",
    simCancelar: "sí, cancelar",
    usuarios: "usuarios",
    dadosDeAcessoResponsabilidades: "datos de acceso y responsabilidades",
    atributosParaAlocacaoDoProfissional: "atributos para la asignación del profesional",
    criarNovoUsuario: "añadir nuevo usuario",
    usuarioEditado: "Usuario editado!",
    usuario: "Usuario",
    editadoComSucesso: "editado con éxito",
    criadoComSucesso: "creado con éxito",
    erroAoTentarCriarUsuario: "Error al intentar añadir usuario",
    erroAoTentarEditarUsuario: "Error al intentar editar usuario",
    fotoAlterada: "Foto cambiada",
    fotoDoUsuarioAlteradaComSucesso: "La foto del usuario se cambió con éxito",
    erroAoAlterarFoto: "Error al cambiar la foto",
    ocorreuUmErroAoAlterarFoto: "Ocurrió un error al cambiar la foto del usuario",
    usuarioCriado: "Usuario creado!",
    camposInvalidos: "Campos inválidos",
    preenchaCorretamenteOsCampos: "Complete correctamente los campos",
    erroInesperado: "Error inesperado",
    naoFoiPossivelEncontrarUsuario: "No se pudo encontrar al usuario",
  }
}
